import {
  Button,
  Col,
  Form,
  Popconfirm,
  Popover,
  Row,
  Space,
  Spin,
  Tooltip,
} from "antd";
import {
  ButtonExcel,
  ColumnPopoverDisplay,
  ExpandSearch,
  InputFields,
  ModalCustom,
} from "components/common";
import React, {useEffect, useRef, useState} from "react";
import {allColumns, field, fieldQuyetToan} from "./PushDataXML.config";
import {ListIconSVG, ReloadSVG} from "assets";
import {ColumnProps} from "types/models";
import "./PushDataXML.scss";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  setActiveKey,
  setButtonsHeader,
  setSiderKey,
} from "redux/reducer/common";
import {tabKeys} from "types/enums";
import Notification from "components/common/notification/notification";
import InformModal from "./InformModal/InformModal";
import {insuranceService, payService} from "api";
import dayjs, {isDayjs} from "dayjs";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import {
  formatDateToString,
  getTableOptions,
  saveTableOptions,
  exportFile as exportFieldCommon,
} from "helper/common";
import axiosClient from "api/axiosClient";
import CheckDataXML from "./CheckDataXML/CheckDataXML";
import ModalConfirm from "./ModalConfirm/ModalConfirm";

const PushDataXML = () => {
  document.title = "Đẩy dữ liệu XML";
  const informRef = useRef<any>();
  const modalConfirmPushRef = useRef<any>();
  const modalConfirmCheckRef = useRef<any>();
  const modalConfirmDownRef = useRef<any>();
  const checkXMLmRef = useRef<any>();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingBtnDown, setLoadingBtnDown] = useState(false);
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [patientNotValid, setPatientNotValid] = useState<React.Key[]>([]);
  const activeKey = useAppSelector(state => state.common.activeTab);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const [params, setParams] = useState<any>({
    start: dayjs(),
    end: dayjs(),
    khoa: null,
  });
  const [checkPushXML] = Form.useForm();

  let savedTableOption = getTableOptions(
    "PUSHXML_TABLE",
    localStorage.getItem("username")
  );

  const defaultColumns = savedTableOption
    ? allColumns.map(cl => {
        if (savedTableOption.some(it => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(it => it.dataIndex === cl.dataIndex);
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;

  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter(e => e.show == true)
  );

  const setShowColumns = showColumns => {
    saveTableOptions(
      "PUSHXML_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  useEffect(() => {
    dispatch(setButtonsHeader([]));
    dispatch(setActiveKey(tabKeys.XML.PUSH_XML));
    dispatch(setSiderKey("dayDuLieuXml"));
  }, [activeKey]);

  const getDataXML = async () => {
    setLoading(true);
    try {
      const response = await payService.getPushXMLData(formatParams());
      const newData = response.map(item => ({
        ...item,
        key: item.maPhieuKham,
      }));
      setData(newData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
    }
  };

  columns.map(col => {
    if (col.dataIndex == "action") {
      col.render = (value, record, index) => {
        return (
          <Tooltip title="Tra cứu thẻ BHYT">
            <Button
              type="primary"
              onClick={() => handleOnCheck(record)}
              icon={<ReloadSVG />}
            ></Button>
          </Tooltip>
        );
      };
    }
  });

  const handleOnCheck = async record => {
    // setLoading(true);
    try {
      const res = await insuranceService.checkInsurance({
        mathe: record.soTheBHYT,
        hoten: record.hoTen,
        namsinh: record.ngaySinh,
        // namsinh: record.ngaySinh.year(),
      });
      if (res.status == 200) {
        informRef.current?.setData({...res.data});
        informRef.current?.openModal();
        // setLoading(false);
      }
      if (res.status == 404) {
        Notification("error", "Không tìm thấy thông tin");
        // setLoading(false);
      }
    } catch (err) {
      if (err.response.status == 400) {
        Notification("error", "Không tìm thấy thông tin");
        // setLoading(false);
      } else {
        // setLoading(false);
        Notification("error", "Lỗi xảy ra khi lấy thông tin bảo hiểm y tế");
      }
    }
  };

  const handleExportExcel = async () => {
    const searchFields = await expandRef.current?.getValidateField();

    const param = {
      ...searchFields,
      ...formatParams(),
    };
    if (param?.start != null || param.end !== null) {
      exportFieldCommon(
        `/qlttbhyt-service/day-du-lieu/export-ds-benh-nhan`,
        param,
        `Báo cáo dữ liệu XML`
      );
      // } else {
      //   Notification("warning", "Chưa chọn ngày để xuất báo cáo");
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: async (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      // console.log(
      //   `selectedRowKeys: ${selectedRowKeys}`,
      //   "selectedRows: ",
      //   selectedRows
      // );
      setSelectedRows(selectedRows);
      // const selectedRowStatuses = selectedRows.filter((row) => row.status == 0);
      // setDataPay(selectedRowStatuses);
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  const formatParams = () => {
    return {
      ...params,
      start: formatDateToString(params.start),
      end: formatDateToString(params.end),
    };
  };
  useEffect(() => {
    if (params.khoa) {
      getDataXML();
      checkXMLmRef.current.setData([]);
    }
  }, [params]);
  const onClickSearchButton = async () => {
    const searchFields = await expandRef.current?.getValidateField();

    setParams({
      ...params,
      ...searchFields,
    });
  };
  //Đẩy dữ liệu xml
  const checkTimeQuyetToan = fieldCheckPush => {
    // a Thắng check thời gian như a Trang nói ở đây nhé
    const tempArr = [];
    let result: boolean = false;

    selectedRows.map(el => {
      if (
        dayjs(el.ngayXuatVien).add(1, "month").month() ==
          fieldCheckPush.thangQT &&
        dayjs(el.ngayXuatVien).year() == fieldCheckPush.namQT
      ) {
        return true;
      } else {
        tempArr.push(el);
        return false;
      }
    });
    if (tempArr.length < 0 || !tempArr) {
      result = true;
    }
    setPatientNotValid(tempArr);
    return result;
  };
  //check dữ liệu xml
  const handleCheckXMLData = async () => {
    if (!selectedRows) {
      Notification("warning", "Chưa chọn dữ liệu để kiểm tra XML");
    }
    const checkPush = checkPushXML.getFieldsValue();
    if (!checkPush.namQT || !checkPush.thangQT) {
      Notification("warning", "Vui lòng chọn đầy đủ tháng và năm quyết toán!");
      return;
    }
    if (!checkTimeQuyetToan(checkPush)) {
      modalConfirmCheckRef?.current?.openModal();
    } else {
      submitCheck();
    }
  };
  const handlePushXMLData = async () => {
    if (!selectedRows) {
      Notification("warning", "Chưa chọn dữ liệu để tải XML");
      return;
    }
    const checkPush = checkPushXML.getFieldsValue();
    if (!checkPush.namQT || !checkPush.thangQT) {
      Notification("warning", "Vui lòng chọn đầy đủ tháng và năm quyết toán!");
      return;
    }
    if (!checkTimeQuyetToan(checkPush)) {
      modalConfirmPushRef?.current?.openModal();
    } else {
      submitPush();
    }
  };
  const handleDownXMLData = async () => {
    if (!selectedRows) {
      Notification("warning", "Chưa chọn dữ liệu để tải XML");
      return;
    }
    const checkPush = checkPushXML.getFieldsValue();
    if (!checkPush.namQT || !checkPush.thangQT) {
      Notification("warning", "Vui lòng chọn đầy đủ tháng và năm quyết toán!");
      return;
    }
    if (!checkTimeQuyetToan(checkPush)) {
      modalConfirmDownRef?.current?.openModal();
    } else {
      submitDown();
    }
  };
  const submitDown = async () => {
    const checkPush = checkPushXML.getFieldsValue();

    const dataPush = [];
    selectedRows.map(item => {
      dataPush.push(item.maPhieuKham);
    });
    setLoading(true);
    const dataPushXML = {
      idPhieuKhams: dataPush,
      thangQT: checkPush.thangQT,
      namQT: checkPush.namQT,
    };
    try {
      exportFile(
        "/qlttbhyt-service/day-du-lieu/get-xml",
        dataPushXML,
        `Dữ liệu XML`,
        "xml"
      );
      setLoading(false);
    } catch (error) {
      setLoading(true);
      Notification(
        "error",
        error?.response?.data ?? "Tải dữ liệu XML không thành công"
      );
    }
  };
  const submitPush = async () => {
    const checkPush = checkPushXML.getFieldsValue();

    const dataPush = [];
    selectedRows.map(item => {
      dataPush.push(item.maPhieuKham);
    });
    setLoading(true);
    const dataPushXML = {
      idPhieuKhams: dataPush,
      thangQT: checkPush.thangQT,
      namQT: checkPush.namQT,
    };
    try {
      await payService.pushXMLData(dataPushXML);
      Notification("success", "Đẩy dữ liệu XML thành công");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đẩy dữ liệu XML không thành công");
    }
  };
  //xuất file
  const submitCheck = async () => {
    const checkPush = checkPushXML.getFieldsValue();

    const dataPush = [];
    selectedRows.map(item => {
      dataPush.push(item.maPhieuKham);
    });
    setLoading(true);
    const dataPushXML = {
      idPhieuKhams: dataPush,
      thangQT: checkPush.thangQT,
      namQT: checkPush.namQT,
    };
    try {
      const res = await payService.checkXMLData(dataPushXML);
      checkXMLmRef.current.setData(res);
      checkXMLmRef.current.openModal();
      Notification("success", "Kiểm tra dữ liệu XML thành công");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Kiểm tra dữ liệu XML không thành công");
    }
  };
  const exportFile = async (urlApi, params, nameFile, extension = "xlsx") => {
    try {
      const res = await axiosClient.post(urlApi, params, {
        responseType: "blob",
      });
      var link = document.createElement("a");
      const url = window.URL.createObjectURL(res.data);
      link.href = url;
      link.download = `${nameFile}.${extension}`;
      link.click();
      Notification("success", "Đã xuất file báo cáo");
    } catch (error) {
      Notification("error", "Đã có lỗi khi xuất file báo cáo");
    }
  };
  //tải dữ liệu về
  // const handleDownXMLData = async () => {
  //   if (!selectedRows) {
  //     Notification("warning", "Chưa chọn dữ liệu để tải XML");
  //   }
  //   const dataPush = [];
  //   selectedRows.map(item => {
  //     dataPush.push(item.maPhieuKham);
  //   });
  //   setLoadingBtnDown(true);
  //   try {
  //     exportFile(
  //       "/qlttbhyt-service/day-du-lieu/get-xml",
  //       {idPhieuKhams: dataPush},
  //       `Dữ liệu XML`,
  //       "xml"
  //     );
  //     setLoadingBtnDown(false);
  //   } catch (error) {
  //     setLoadingBtnDown(false);
  //     Notification(
  //       "error",
  //       error?.response?.data ?? "Tải dữ liệu XML không thành công"
  //     );
  //   }
  // };
  return (
    <Spin spinning={loading}>
      <div className="push-data-xml page">
        <div className="main">
          <div className="container">
            <Space direction="vertical" style={{width: "100%"}}>
              <ExpandSearch
                ref={expandRef}
                onClickSearch={onClickSearchButton}
                fields={field}
                onReset={onClickSearchButton}
                initialValues={params}
                isResetField={false}
                isSearchExpend={false}
                isShowDetail={false}
              ></ExpandSearch>
            </Space>
          </div>
          <div className="container">
            <Row justify={"space-between"} style={{marginBottom: "16px"}}>
              <Col>
                <div className="header">Danh sách</div>
              </Col>

              <Col>
                <Space style={{width: "100%"}}>
                  <Form
                    layout="inline"
                    style={{width: 600}}
                    form={checkPushXML}
                  >
                    <Row>
                      <InputFields data={fieldQuyetToan}></InputFields>
                    </Row>
                  </Form>
                  <ButtonExcel
                    // disabled={!data ? true : false}
                    onClick={handleExportExcel}
                  ></ButtonExcel>

                  <Popover
                    trigger="click"
                    placement="topLeft"
                    content={
                      <ColumnPopoverDisplay
                        setShowColumns={setShowColumns}
                        columns={defaultColumns}
                      ></ColumnPopoverDisplay>
                    }
                  >
                    <Button
                      type="primary"
                      className="btn-sub"
                      icon={<ListIconSVG />}
                    >
                      Cột hiển thị
                    </Button>
                  </Popover>
                  <Popconfirm
                    title={"Bạn có chắc chắn muốn đẩy dữ liệu?"}
                    onConfirm={handlePushXMLData}
                  >
                    <Button type="primary" disabled={!data ? true : false}>
                      Đẩy dữ liệu XML
                    </Button>
                  </Popconfirm>
                  <Button
                    type="primary"
                    onClick={handleCheckXMLData}
                    disabled={!data ? true : false}
                  >
                    Kiểm tra dữ liệu XML
                  </Button>
                  <Button
                    type="primary"
                    onClick={handleDownXMLData}
                    disabled={!data ? true : false}
                    loading={loadingBtnDown}
                  >
                    Tải dữ liệu XML
                  </Button>
                </Space>
              </Col>
            </Row>
            <CustomResizableTable
              setShowColumns={setShowColumns}
              bordered
              pagination={{showSizeChanger: true}}
              rowSelection={{
                ...rowSelection,
              }}
              scroll={{x: 1500}}
              columns={columns}
              dataSource={data}
            ></CustomResizableTable>
          </div>
        </div>
        <InformModal
          ref={informRef}
          // onSave={onSave}
          // onClose={onClose}
        />
        <CheckDataXML ref={checkXMLmRef} />
        <ModalCustom title="Xác nhận" width={600} ref={modalConfirmPushRef}>
          <ModalConfirm
            submit={submitPush}
            data={patientNotValid}
            text="đẩy XML"
          ></ModalConfirm>
        </ModalCustom>
        <ModalCustom title="Xác nhận" width={600} ref={modalConfirmCheckRef}>
          <ModalConfirm
            submit={submitCheck}
            data={patientNotValid}
            text="kiểm tra XML"
          ></ModalConfirm>
        </ModalCustom>
        <ModalCustom title="Xác nhận" width={600} ref={modalConfirmDownRef}>
          <ModalConfirm
            submit={submitDown}
            data={patientNotValid}
            text="tải XML"
          ></ModalConfirm>
        </ModalCustom>
      </div>
    </Spin>
  );
};

export default PushDataXML;
